var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.53933C15.4113 1.80067 14.7787 1.97667 14.1147 2.056C14.7927 1.65 15.3133 1.00667 15.558 0.24C14.924 0.616 14.2213 0.889333 13.4733 1.03667C12.8753 0.398667 12.0213 0 11.0773 0C8.958 0 7.40067 1.97733 7.87933 4.03C5.152 3.89333 2.73333 2.58667 1.114 0.600667C0.254 2.076 0.668 4.006 2.12933 4.98333C1.592 4.966 1.08533 4.81867 0.643333 4.57267C0.607333 6.09333 1.69733 7.516 3.276 7.83267C2.814 7.958 2.308 7.98733 1.79333 7.88867C2.21067 9.19267 3.42267 10.1413 4.86 10.168C3.48 11.25 1.74133 11.7333 0 11.528C1.45267 12.4593 3.17867 13.0027 5.032 13.0027C11.1267 13.0027 14.57 7.85533 14.362 3.23867C15.0033 2.77533 15.56 2.19733 16 1.53933Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e68730aba80f3f711f88dffcafb32f86.svg";
export { ForwardRef as ReactComponent };